/* EMPRICS product configurator v1.6 (27/10/26)
   v1.6 (David's ruling 18:25): every SKU position is shown on every product, in code order (wattage, control, colour
   rendering, colour temperature, beam, optic, finish, option, emergency), even when the family offers one choice; a
   single choice shows selected. Each option carries its code characters, and each position heading shows the code it
   writes into the SKU, so clients learn the logic. Placeholder codes read "None" (0, 00) or "Not applicable" (X, XX).
   v1.5: attributes with one value (for example switchable wattage on BH1020) show as a fixed specification list
   instead of vanishing; the register data call retries once with a timeout; a family the register does not hold
   (404) keeps the legacy builder, while a network failure keeps this section with a contact message and never
   exposes the legacy placeholder code (FAMILY.00X000.XXXXXX.00). The register response (codes, labels, live
   specification rows) is shared with emprics-family.js through window.EmpricsConfigurator.data and the
   "emp-cfg:data" event, so the specification table follows the register without a theme upload.
   v1.4: mounts in the product information column beside the image.
   v1.3: legacy builder removed only after the register data loads; Add to Quote into the site-wide Quote List.
   v1.2: placeholder codes show the code, never a "No beam" style label.
   v1.1: reads codes segment by segment (3-digit wattage and lamp holder codes), family-aware titles. */
(function () {
  'use strict';

  var ORDER = ['option', 'wattage', 'cct', 'cri', 'beam', 'optic', 'colour', 'driver'];
  var DEFAULTS = { option: '0', wattage: '15', cct: '30', cri: '9', beam: '40', optic: 'RA', colour: 'PW', driver: 'D' };
  var LEGACY = '.emprics-pdp__configurator, .emprics-pdp__summary-sku-row, .emprics-pdp__summary-sentence, ' +
    '.emprics-pdp__summary-actions, .emprics-pdp__cta-spec-copy, .emprics-pdp__acc-inline, .emprics-pdp__stickybar, .emprics-pdp__drawer';
  var QUOTE_KEY = 'emprics_quote_list';
  var PLACEHOLDER = /^(0|00|000|X|XX)$/;
  var TIMEOUT_MS = 10000;

  var shared = window.EmpricsConfigurator = window.EmpricsConfigurator || {};
  shared.data = shared.data || {};

  function releaseLegacy() { document.documentElement.classList.remove('emp-cfg-pending'); }

  function stripLegacy() {
    document.querySelectorAll(LEGACY).forEach(function (el) { el.remove(); });
    document.querySelectorAll('.emprics-pdp__summary').forEach(function (el) {
      if (!el.querySelector('.emprics-pdp__datasheet-link')) el.remove();
    });
    releaseLegacy();
  }

  function titlesFor(family, lampHolder) {
    var dl = /^(DL|TL)/.test(family);
    return {
      option: dl ? 'Head' : 'Version',
      wattage: lampHolder ? 'Lamp holder' : 'Wattage',
      cct: 'Colour temperature',
      cri: 'Colour rendering',
      beam: 'Beam',
      optic: dl ? 'Reflector or cover finish' : 'Optic',
      colour: dl ? 'Trim finish' : 'Finish',
      driver: 'Control'
    };
  }

  // base = everything after "FAMILY." except the emergency character, e.g. 15D930.40RAPW.0
  function parse(base) {
    var s = base.split('.'), b = s[0] || '', c = s[1] || '', d = s[2] || '';
    var lh = /^\d{1,3}X[A-Z0-9.]+$/.test(b);
    return {
      wattage: lh ? b : b.slice(0, -4), driver: lh ? '' : b.slice(-4, -3), cri: lh ? '' : b.slice(-3, -2), cct: lh ? '' : b.slice(-2),
      beam: c.slice(0, 2), optic: c.slice(2, 4), colour: c.slice(4, 6), option: d
    };
  }

  function labelFor(labels, key, v) {
    if (labels[key] && labels[key][v] && labels[key][v].l && labels[key][v].l !== v) return labels[key][v].l;
    var lhm = key === 'wattage' && v.match(/^(\d{1,3})X([A-Z0-9.]+)$/);
    if (lhm) return parseInt(lhm[1], 10) + ' x ' + lhm[2] + ' lamp holder';
    if (/^0+$/.test(v)) return key === 'option' ? 'Standard' : (key === 'emergency' ? 'No emergency' : 'None');
    if (/^X+$/.test(v)) return 'Not applicable';
    if (key === 'wattage' && /^\d+$/.test(v)) return String(parseInt(v, 10)) + 'W';
    if (key === 'beam' && /^\d+$/.test(v)) return String(parseInt(v, 10)) + '°';
    return v;
  }
  function sortFor(labels, key, v) {
    if (labels[key] && labels[key][v] && labels[key][v].s != null) return labels[key][v].s;
    var n = parseInt(v, 10);
    return isNaN(n) ? 999 : n;
  }

  function getJSON(url) {
    var ctl = window.AbortController ? new AbortController() : null;
    var t = ctl ? setTimeout(function () { ctl.abort(); }, TIMEOUT_MS) : null;
    return fetch(url, ctl ? { signal: ctl.signal } : {}).then(function (r) {
      if (t) clearTimeout(t);
      if (!r.ok) { var e = new Error(String(r.status)); e.status = r.status; throw e; }
      return r.json();
    }, function (e) { if (t) clearTimeout(t); throw e; });
  }

  function Configurator(root) {
    this.root = root;
    this.family = root.dataset.family;
    this.handle = root.dataset.handle || this.family.toLowerCase();
    this.title = root.dataset.title || this.family;
    this.image = root.dataset.image || '';
    this.type = root.dataset.type || '';
    this.endpoint = root.dataset.endpoint;
    this.quoteUrl = root.dataset.quoteUrl;
    this.replaceLegacy = root.dataset.replaceLegacy === 'true';
    this.cache = {};
    this.sel = {};
    this.emergency = '0';
    this.load(0);
  }

  // The register does not hold this family: remove this section and keep the legacy builder.
  Configurator.prototype.fallBack = function () {
    this.root.remove();
    releaseLegacy();
    document.dispatchEvent(new CustomEvent('emp-cfg:data', { detail: { family: this.family, data: null } }));
  };

  // The register holds the family but could not be reached: keep this section, show a contact line, and keep the
  // legacy placeholder code off the page.
  Configurator.prototype.unavailable = function () {
    var st = this.root.querySelector('[data-cfg-status]');
    st.textContent = 'The code builder is temporarily unavailable. Request a quote with the family code, or call T: +44 (0) 330 174 4444.';
    if (this.replaceLegacy) { this.mountSide(); stripLegacy(); } else releaseLegacy();
    document.dispatchEvent(new CustomEvent('emp-cfg:data', { detail: { family: this.family, data: null } }));
  };

  Configurator.prototype.load = function (attempt) {
    var self = this;
    getJSON(this.endpoint + '?family=' + encodeURIComponent(this.family))
      .then(function (d) {
        if (!d || !d.codes || !d.codes.length) { self.fallBack(); return; }
        shared.data[self.family] = d;
        self.init(d);
        document.dispatchEvent(new CustomEvent('emp-cfg:data', { detail: { family: self.family, data: d } }));
      })
      .catch(function (e) {
        if (e && e.status === 404) { self.fallBack(); return; }
        if (attempt < 1) { setTimeout(function () { self.load(attempt + 1); }, 1500); return; }
        self.unavailable();
      });
  };

  Configurator.prototype.init = function (d) {
    var self = this;
    this.codes = d.codes;
    this.parsed = d.codes.map(parse);
    this.labels = {};
    (d.labels || []).forEach(function (x) { (self.labels[x.p] = self.labels[x.p] || {})[x.c] = x; });
    var lampHolder = this.parsed.some(function (p) { return /^\d{1,3}X/.test(p.wattage); });
    this.titles = titlesFor(this.family, lampHolder);
    this.values = {};
    ORDER.forEach(function (k) {
      var seen = {};
      self.parsed.forEach(function (p) { if (p[k] !== '') seen[p[k]] = 1; });
      self.values[k] = Object.keys(seen).sort(function (a, b) {
        return sortFor(self.labels, k, a) - sortFor(self.labels, k, b) || (a < b ? -1 : 1);
      });
    });
    this.emergencyValues = (d.emergency || ['0']).slice().sort(function (a, b) {
      return sortFor(self.labels, 'emergency', a) - sortFor(self.labels, 'emergency', b);
    });
    if (this.emergencyValues.indexOf('0') < 0 && this.emergencyValues.length) this.emergency = this.emergencyValues[0];
    // v1.5: the intro under the product title restated from the register (the stored description runs its title and
    // first paragraph together once tags are stripped).
    var lede = document.querySelector('.emprics-pdp__lede');
    if (lede && d.summary) lede.textContent = d.summary;
    this.resolve(DEFAULTS, null);
    this.build();
    this.root.querySelector('[data-cfg-status]').hidden = true;
    this.root.querySelector('[data-cfg-body]').hidden = false;
    this.render();
    if (this.replaceLegacy) { this.mountSide(); stripLegacy(); } else releaseLegacy();
  };

  Configurator.prototype.mountSide = function () {
    if (this.root.classList.contains('emp-cfg--side')) return;
    var legacy = document.querySelector('.emprics-pdp__configurator');
    var host = legacy || document.querySelector('.emprics-pdp__summary');
    if (!host || !host.parentNode) return;
    // Never mount inside the summary card: stripLegacy removes that card when it holds no datasheet link.
    while (host.parentNode && host.parentNode.classList && host.parentNode.classList.contains('emprics-pdp__summary')) host = host.parentNode;
    host.parentNode.insertBefore(this.root, host);
    this.root.classList.add('emp-cfg--side');
  };

  Configurator.prototype.resolve = function (wanted, fixedKey) {
    var best = -1, bestScore = -1;
    for (var i = 0; i < this.parsed.length; i++) {
      var p = this.parsed[i];
      if (fixedKey && p[fixedKey] !== wanted[fixedKey]) continue;
      var score = 0;
      for (var j = 0; j < ORDER.length; j++) if (p[ORDER[j]] === wanted[ORDER[j]]) score += 1 << (ORDER.length - j);
      if (score > bestScore) { bestScore = score; best = i; }
    }
    if (best < 0) best = 0;
    this.sel = this.parsed[best];
    this.base = this.codes[best];
  };

  Configurator.prototype.available = function (key, v) {
    var sel = this.sel;
    return this.parsed.some(function (p) {
      return ORDER.every(function (k) { return k === key ? p[k] === v : p[k] === sel[k]; });
    });
  };

  Configurator.prototype.build = function () {
    var self = this, wrap = this.root.querySelector('[data-cfg-pickers]');
    // v1.6: every SKU position in code order, single choices included and shown selected.
    var DISPLAY = ['wattage', 'driver', 'cri', 'cct', 'beam', 'optic', 'colour', 'option'];
    var groups = DISPLAY.map(function (k) { return { key: k, title: self.titles[k], values: self.values[k] }; });
    groups.push({ key: 'emergency', title: 'Emergency', values: this.emergencyValues });

    var intro = document.createElement('p');
    intro.className = 'emp-cfg__logic';
    intro.textContent = 'Every product code follows the same order: family, wattage, control, colour rendering, colour temperature, beam, optic, finish, option, emergency. Each choice below writes its code into your SKU.';
    wrap.appendChild(intro);

    groups.forEach(function (g) {
      var fs = document.createElement('fieldset');
      fs.className = 'emp-cfg__group' + (g.values.length < 2 ? ' emp-cfg__group--single' : '');
      var lg = document.createElement('legend');
      lg.className = 'emp-cfg__legend';
      var t = document.createElement('span'); t.textContent = g.title;
      var c = document.createElement('span'); c.className = 'emp-cfg__legend-code'; c.dataset.cfgLegend = g.key;
      lg.appendChild(t); lg.appendChild(c);
      fs.appendChild(lg);
      var row = document.createElement('div');
      row.className = 'emp-cfg__options';
      if (!g.values.length) {
        // lamp-holder codes carry no control, rendering or colour temperature position
        var na = document.createElement('span');
        na.className = 'emp-cfg__opt emp-cfg__opt--na';
        na.setAttribute('aria-pressed', 'true');
        na.textContent = 'Not applicable (lamp holder code)';
        row.appendChild(na);
      }
      g.values.forEach(function (v) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'emp-cfg__opt';
        b.dataset.key = g.key;
        b.dataset.value = v;
        var l = document.createElement('span'); l.textContent = labelFor(self.labels, g.key, v);
        var tag = document.createElement('span'); tag.className = 'emp-cfg__tag'; tag.textContent = v;
        b.appendChild(l); b.appendChild(tag);
        if (g.values.length < 2) b.title = 'The only option for this product';
        b.addEventListener('click', function () { self.choose(g.key, v); });
        row.appendChild(b);
      });
      fs.appendChild(row);
      wrap.appendChild(fs);
    });
    this.root.querySelector('[data-cfg-copy]').addEventListener('click', function () { self.copy(self.fullCode(), this); });
    this.root.querySelector('[data-cfg-copy-desc]').addEventListener('click', function () {
      self.copy(self.root.querySelector('[data-cfg-desc]').textContent, this);
    });
    this.root.querySelectorAll('[data-cfg-add]').forEach(function (btn) {
      btn.addEventListener('click', function () { self.addToQuote(this); });
    });
  };

  Configurator.prototype.addToQuote = function (btn) {
    var code = this.fullCode();
    var desc = (this.cache[code] && this.cache[code].description) || this.root.querySelector('[data-cfg-desc]').textContent || '';
    var item = { handle: this.handle + '?sku=' + code, title: code, sku: code, image: this.image, type: this.type, description: desc };
    var items;
    try { items = JSON.parse(localStorage.getItem(QUOTE_KEY) || '[]'); } catch (e) { items = []; }
    var found = items.filter(function (i) { return i.handle === item.handle; })[0];
    if (found) { found.qty = (found.qty || 1) + 1; found.description = desc || found.description; }
    else { item.qty = 1; item.ref = ''; items.push(item); }
    try { localStorage.setItem(QUOTE_KEY, JSON.stringify(items)); } catch (e) {}
    if (window.EmpricsQuote && window.EmpricsQuote.updateBadges) window.EmpricsQuote.updateBadges();
    else document.querySelectorAll('.emprics-quote-badge').forEach(function (b) { b.textContent = items.length; b.style.display = 'inline-flex'; });
    var t = btn.textContent; btn.textContent = 'Added to Quote List';
    btn.classList.add('is-added');
    var view = this.root.querySelector('[data-cfg-view]');
    if (view) view.hidden = false;
    setTimeout(function () { btn.textContent = t; btn.classList.remove('is-added'); }, 1600);
  };

  Configurator.prototype.choose = function (key, v) {
    if (key === 'emergency') { this.emergency = v; this.render(); return; }
    var wanted = {}, self = this;
    ORDER.forEach(function (k) { wanted[k] = self.sel[k]; });
    wanted[key] = v;
    this.resolve(wanted, key);
    this.render();
  };

  Configurator.prototype.fullCode = function () { return this.family + '.' + this.base + this.emergency; };

  Configurator.prototype.render = function () {
    var self = this;
    this.root.querySelectorAll('.emp-cfg__opt').forEach(function (b) {
      var k = b.dataset.key, v = b.dataset.value;
      var on = k === 'emergency' ? v === self.emergency : self.sel[k] === v;
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
      b.classList.toggle('is-dimmed', k !== 'emergency' && !on && !self.available(k, v));
    });
    this.root.querySelectorAll('[data-cfg-legend]').forEach(function (el) {
      var k = el.dataset.cfgLegend, v = k === 'emergency' ? self.emergency : self.sel[k];
      el.textContent = v ? v : '';
    });
    var code = this.fullCode();
    this.root.querySelector('[data-cfg-code]').textContent = code;
    var mini = this.root.querySelector('[data-cfg-mini]');
    if (mini) mini.textContent = code;
    var quote = this.root.querySelector('[data-cfg-quote]');
    if (quote) quote.href = this.quoteUrl + (this.quoteUrl.indexOf('?') < 0 ? '?' : '&') + 'code=' + encodeURIComponent(code);
    this.describe(code);
  };

  Configurator.prototype.describe = function (code) {
    var self = this, desc = this.root.querySelector('[data-cfg-desc]'), ldt = this.root.querySelector('[data-cfg-ldt]');
    var show = function (d) {
      if (code !== self.fullCode()) return;
      desc.textContent = d.description || '';
      if (d.ldt) { ldt.href = d.ldt; ldt.hidden = false; } else { ldt.hidden = true; }
    };
    if (this.cache[code]) { show(this.cache[code]); return; }
    desc.textContent = 'Loading specification…';
    clearTimeout(this.timer);
    this.timer = setTimeout(function () {
      getJSON(self.endpoint + '?code=' + encodeURIComponent(code))
        .then(function (d) { self.cache[code] = d; show(d); })
        .catch(function () { if (code === self.fullCode()) { desc.textContent = ''; ldt.hidden = true; } });
    }, 120);
  };

  Configurator.prototype.copy = function (text, btn) {
    var done = function () {
      var t = btn.textContent; btn.textContent = 'Copied';
      setTimeout(function () { btn.textContent = t; }, 1400);
    };
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(text).then(done, function () {});
    }
  };

  function boot() {
    var els = document.querySelectorAll('[data-emp-cfg]');
    if (!els.length) releaseLegacy();
    els.forEach(function (el) {
      if (!el.__empCfg) el.__empCfg = new Configurator(el);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  shared.boot = boot; shared._Configurator = Configurator; shared._parse = parse;
})();
